module.exports = __webpack_public_path__ + "img/mapimg7.885940f3.png";